import { fetcher } from "../api/fetcher";
import { activeRoomState } from "../states/active_room";
import { authState } from "../states/auth";
import { roomState, serverDiffTime } from "../states/room";
import {
  Participant,
  RemoteParticipant,
  RemoteTrack,
  RemoteTrackPublication,
  RoomEvent,
  Track,
} from "livekit-client";
import { usersVideoTracks } from "../states/usersVideoStreams";
import { ref } from "vue";
import { setSpeakers } from "../states/currentSpeakers";
import { goFinish } from "../states/finishState";
import EgressHelper from "@livekit/egress-sdk";
import { subscribe_sync_info } from "./syncInfo";
import {
  newScreenTrackByLivekit,
  removeScreenTrackByLivekit,
  subscribeScreenShareEvents,
} from "../states/screenShareState";
import {
  subscribeConnectUser,
  subscribeDisconnectUser,
  subscribeKickUser,
  subscribeUpdateUser,
} from "../states/usersState";
import { subscribeHandUp } from "../states/handUpState";
import { SelectTab } from "../states/viewState";
import { subscribeMuteUser } from "../states/media/state";
import { createLivekitRoomInstance } from "../states/media/livekit";
import { apiConnected } from "../states/media/api";

const first_connected = ref(false);

export async function connectRecord() {
  activeRoomState.mode = "speaker";
  SelectTab("users");
  subscribeConnectUser();
  subscribeUpdateUser();
  subscribeKickUser();
  subscribeDisconnectUser();
  subscribeScreenShareEvents();
  subscribeMuteUser();
  subscribe_sync_info();
  subscribeHandUp();
  const user = {
    id: authState.id,
  };
  const res = (await fetcher.post({
    path: "/active-room/connect-recorder",
    payload: {
      user: user,
      room_id: roomState.id,
    },
  })) as {
    token: string;
    serverTime: number;
  };

  activeRoomState.selfApiConnected = true;
  apiConnected({ camera: false, micro: false });

  serverDiffTime.value = Date.now() - res.serverTime;
  const room = createLivekitRoomInstance({
    adaptiveStream: {
      pixelDensity: window.devicePixelRatio + 2,
    },
  });
  room
    .on(RoomEvent.Disconnected, handleDisconnected)
    .on(RoomEvent.Connected, handleConnected)
    .on(RoomEvent.TrackSubscribed, handleTrackSubscribed)
    .on(RoomEvent.TrackUnsubscribed, handleTrackUnsubscribed)
    .on(RoomEvent.ActiveSpeakersChanged, handleActiveSpeakerChange);

  function handleTrackSubscribed(
    track: RemoteTrack,
    _pub: RemoteTrackPublication,
    user: RemoteParticipant,
  ) {
    if (track.kind === Track.Kind.Audio) {
      track.attach();
    } else if (track.kind === Track.Kind.Video) {
      if (track.source === "screen_share") {
        newScreenTrackByLivekit(track, user.identity);
        track.once("ended", () => {
          removeScreenTrackByLivekit(user.identity);
        });
      } else {
        usersVideoTracks[user.identity] = track;
      }
    }
  }

  function handleTrackUnsubscribed(
    track: RemoteTrack,
    _pub: RemoteTrackPublication,
    user: RemoteParticipant,
  ) {
    if (track.kind === Track.Kind.Video) {
      track.detach();
      if (track.source === "screen_share") {
        removeScreenTrackByLivekit(user.identity);
      } else {
        usersVideoTracks[user.identity] = null;
      }
    } else if (track.kind === Track.Kind.Audio) {
      track.detach();
    }
  }

  function handleActiveSpeakerChange(speakers: Participant[]) {
    setSpeakers(speakers.map((s) => s.identity));
  }

  function handleDisconnected() {
    console.log("live disconnected");
    if (first_connected.value) {
      goFinish("network");
    }
  }

  function handleConnected() {
    console.log("live connected");
  }

  for (let i = 0; i < 3; i++) {
    try {
      await room.connect(
        EgressHelper.getLiveKitURL(),
        EgressHelper.getAccessToken(),
        {
          websocketTimeout: 5000,
          peerConnectionTimeout: 5000,
        },
      );
      EgressHelper.setRoom(room);
      EgressHelper.startRecording();
      first_connected.value = true;
      break;
    } catch (err) {
      if (i == 2) {
        goFinish("network");
        throw "err on first connect";
      }
    }
  }
}
